import { render } from "./Calendario.vue?vue&type=template&id=06f48aa0&scoped=true"
import script from "./Calendario.vue?vue&type=script&lang=js"
export * from "./Calendario.vue?vue&type=script&lang=js"

import "./Calendario.vue?vue&type=style&index=0&id=06f48aa0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06f48aa0"]])

export default __exports__